var _g, _polygon, _polygon2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgStaplers = function SvgStaplers(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "staplers",
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "399.38 461.85 107.05 309.73 101.25 323.58 394.02 475.93 398.82 463.32 399.38 461.85",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.81 439.67 107.52 282.78 98.17 305.11 107.05 309.73 399.38 461.85 407.81 439.67",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.69,491.1l-310.03-119.53c.05-.13.08-.22.12-.31-.87,2.3-4.9,12.88-7.49,19.7l310.59,118.06,6.81-17.92Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.77,371.25c.21-.56.23-.61,0,0h0Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551.11,416.84S191.45,228.51,145.06,217.03c-32.17-7.96-55.02,18.77-65.73,35.31-4.08,6.31-1.85,14.74,4.81,18.22l23.38,12.21,300.29,156.89-8.43,22.18-.56,1.47-4.79,12.61-12.65,33.27-.5-.19-310.59-118.06-41.11-15.63c-6.58-2.5-13.95.81-16.45,7.39s.81,13.95,7.39,16.45l471.82,179.34s63.37,12.72,89.8-56.81c26.93-70.85-30.62-104.86-30.62-104.86Zm1.92,87.78c-11.68,30.72-46.05,46.16-76.77,34.48-30.72-11.68-46.16-46.05-34.48-76.77,11.68-30.72,46.05-46.16,76.77-34.48s46.16,46.05,34.48,76.77Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m518.55,427.85c-30.72-11.68-65.09,3.76-76.77,34.48-11.68,30.72,3.76,65.09,34.48,76.77,30.72,11.68,65.09-3.76,76.77-34.48,11.68-30.72-3.76-65.09-34.48-76.77Zm14.36,69.12c-7.45,19.61-29.39,29.46-48.99,22.01s-29.46-29.39-22.01-48.99c7.45-19.61,29.39-29.46,48.99-22.01,19.61,7.45,29.46,29.39,22.01,48.99Z",
    fill: "#93b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.9,447.98c-19.61-7.45-41.54,2.4-48.99,22.01-7.45,19.61,2.4,41.54,22.01,48.99s41.54-2.4,48.99-22.01c7.45-19.61-2.4-41.54-22.01-48.99Zm3.13,41.82c-3.49,9.18-13.77,13.8-22.95,10.31-9.18-3.49-13.8-13.77-10.31-22.95,3.49-9.18,13.77-13.8,22.95-10.31,9.18,3.49,13.8,13.77,10.31,22.95Z",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497.41,
    cy: 483.48,
    r: 17.79,
    transform: "translate(-172.49 303.47) rotate(-29.15)",
    fill: "#6ab4e5"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "88.48 201.51 63.31 127.19 167.82 91.8 192.64 165.09 179.27 161.85 161.99 110.84 80.2 138.54 96.77 187.48 88.48 201.51",
    fill: "#6ab4e5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.68 104.02 241.02 28.51 347.2 58.53 326.15 132.98 316.97 122.74 331.61 70.92 248.51 47.43 234.46 97.15 219.68 104.02",
    fill: "#6ab4e5"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStaplers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/staplers.70b31641.svg";
export { ForwardRef as ReactComponent };